import { useEffect, useState } from 'react';
import { ScopeSwitcher } from '../components/ScopeSwitcher';
import { useScope } from '../lib/hooks';
import { categoriesApi, type Category } from '../lib/domain';
import { ApiError, OfflineError } from '../lib/api';

function errorMessage(err: unknown): string {
  if (err instanceof ApiError) return err.message;
  if (err instanceof OfflineError) return err.message;
  return 'Aktion fehlgeschlagen. Bitte erneut versuchen.';
}

export function CategoriesPage() {
  const [scope] = useScope();
  const [categories, setCategories] = useState<Category[]>([]);
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);

  function reload() {
    if (!scope) return;
    categoriesApi
      .list(scope)
      .then((r) => setCategories(r.categories))
      .catch((err) => setError(errorMessage(err)));
  }

  useEffect(reload, [scope]);

  async function create() {
    if (!scope || !name.trim()) return;
    setError(null);
    try {
      await categoriesApi.create(name.trim(), scope.startsWith('group:') ? scope.slice(6) : undefined);
      setName('');
      reload();
    } catch (err) {
      setError(errorMessage(err));
    }
  }

  async function rename(id: string, current: string) {
    const next = prompt('Neuer Name', current);
    if (!next || !scope) return;
    setError(null);
    try {
      await categoriesApi.rename(id, next);
      reload();
    } catch (err) {
      setError(errorMessage(err));
    }
  }

  async function remove(id: string) {
    if (!scope || !confirm('Kategorie entfernen? Zugeordnete Produkte gelten danach als unkategorisiert.')) return;
    setError(null);
    try {
      await categoriesApi.remove(id);
      reload();
    } catch (err) {
      setError(errorMessage(err));
    }
  }

  return (
    <div className="stack">
      <h1>Kategorien</h1>
      <ScopeSwitcher />
      {error && (
        <p className="error-text" role="alert">
          {error}
        </p>
      )}
      <div className="card row">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Neue Kategorie" />
        <button onClick={create}>Anlegen</button>
      </div>
      <ul className="list-reset stack">
        {categories.map((c) => (
          <li key={c.id} className="card row between">
            <span>
              {c.name} {c.isDefault && <span className="badge">Standard</span>}
            </span>
            <div className="row">
              <button onClick={() => rename(c.id, c.name)}>Umbenennen</button>
              <button className="danger" onClick={() => remove(c.id)}>
                Entfernen
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
